import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { ArrowRightOnRectangleIcon } from "@heroicons/react/24/outline";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const pageTitles = [
  { prefix: "/dashboard", label: "Dashboard" },
  { prefix: "/user", label: "Users" },
  { prefix: "/games", label: "Games" },
  { prefix: "/game-plan", label: "Game Plan" },
  { prefix: "/tasks", label: "Tasks" },
  { prefix: "/history", label: "History" },
  { prefix: "/notifications", label: "Notifications" },
  { prefix: "/settings", label: "Settings" },
  { prefix: "/chart", label: "User Growth Chart" },
];

const getTitle = (pathname) =>
  pageTitles.find((p) => pathname.startsWith(p.prefix))?.label || "Admin Panel";

const Navbar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("No token found");
      }

      const response = await fetch(`${baseUrl}/auth/logout`, {
        method: "GET",
        headers: {
        "Authorization": `Bearer ${token}`
      }
      });

      const result = await response.json();

      if (result?.status === true) {
        toast.success("Logged out successfully");
        localStorage.removeItem("token");
        navigate("/");
      } else {
        toast.error(result.message || "Logout failed");
      }
    } catch (err) {
      toast.error(err.message || "Logout failed");
    }

  };
  return (
    <div className="bg-gray-800 border-b border-gray-700 shadow-lg px-6 py-4 flex justify-between items-center">
      <h2 className="text-lg font-bold text-white">{getTitle(pathname)}</h2>
      <button
        onClick={handleLogout}
        className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-lg shadow-md transition"
      >
        <ArrowRightOnRectangleIcon className="h-5 w-5" />
        Logout
      </button>
    </div>
  );
};

export default Navbar;